export default "__VITE_ASSET__BJGc32xe__"